(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-product-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('premium-product')) {
    customElements.define(
      'premium-product',
      class extends HTMLElement {
        connectedCallback() {
          this.variants = JSON.parse(
            this.querySelector('[data-product-json]').textContent
          );

          this.form = this.querySelector('[data-product-form]');
          this.media = [...this.querySelectorAll('[data-media-id]')];
          this.thumbs = [...this.querySelectorAll('[data-media-target]')];

          this.thumbs.forEach((thumb) => {
            thumb.addEventListener('click', () => {
              this.showMedia(String(thumb.dataset.mediaTarget));
            });
          });

          this.querySelector('[data-gallery-prev]')?.addEventListener(
            'click',
            () => this.moveMedia(-1)
          );

          this.querySelector('[data-gallery-next]')?.addEventListener(
            'click',
            () => this.moveMedia(1)
          );

          this.querySelectorAll('[data-option-value]').forEach((input) => {
            input.addEventListener('change', () => {
              this.onOptionsChange();
            });
          });

          this.querySelector('[data-quantity-minus]')?.addEventListener(
            'click',
            () => this.changeQuantity(-1)
          );

          this.querySelector('[data-quantity-plus]')?.addEventListener(
            'click',
            () => this.changeQuantity(1)
          );

          this.querySelector('[data-size-guide-open]')?.addEventListener(
            'click',
            () => {
              this.querySelector('[data-size-guide-dialog]')?.showModal();
            }
          );

          this.querySelector('[data-size-guide-close]')?.addEventListener(
            'click',
            () => {
              this.querySelector('[data-size-guide-dialog]')?.close();
            }
          );

          this.querySelector('[data-size-guide-dialog]')?.addEventListener(
            'click',
            (event) => {
              if (event.target === event.currentTarget) {
                event.currentTarget.close();
              }
            }
          );

          this.querySelector('[data-buy-now-button]')?.addEventListener(
            'click',
            async (e) => {
              e.preventDefault();
              e.stopImmediatePropagation();

              const id = this.querySelector('[data-variant-id]').value;
              const qty = this.querySelector('[name="quantity"]').value || 1;

              if (!id) return;

              try {
                await fetch('/cart/clear.js', { method: 'POST' });

                await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    items: [{ id: Number(id), quantity: Number(qty) }]
                  })
                });

                window.location.assign('/checkout');
              } catch (err) {
                console.error(err);
              }
            },
            true
          );
        }

        showMedia(id) {
          this.media.forEach((item) => {
            const active = String(item.dataset.mediaId) === id;

            item.hidden = !active;
            item.classList.toggle('is-active', active);
          });

          this.thumbs.forEach((thumb) => {
            const active = String(thumb.dataset.mediaTarget) === id;

            thumb.classList.toggle('is-active', active);
            thumb.setAttribute('aria-current', active ? 'true' : 'false');
          });
        }

        moveMedia(direction) {
          if (!this.media.length) return;

          const current = this.media.findIndex((item) => !item.hidden);
          const next =
            (current + direction + this.media.length) % this.media.length;

          this.showMedia(String(this.media[next].dataset.mediaId));
        }

        selectedOptions() {
          return [...this.querySelectorAll('.pps__option')].map((group) => {
            return group.querySelector('[data-option-value]:checked')?.value;
          });
        }

        onOptionsChange() {
          this.querySelectorAll('.pps__option').forEach((group) => {
            const selected = group.querySelector('[data-option-value]:checked');

            if (selected) {
              const label = group.querySelector('[data-option-label]');

              if (label) {
                label.textContent = selected.value;
              }
            }
          });

          const choices = this.selectedOptions();

          const variant = this.variants.find((item) => {
            return item.options.every((value, index) => {
              return value === choices[index];
            });
          });

          this.updateVariant(variant);
        }

        updateVariant(variant) {
          const button = this.querySelector('[data-add-button]');
          const buyNow = this.querySelector('[data-buy-now-button]');
          const label = this.querySelector('[data-add-label]');
          const variantInput = this.querySelector('[data-variant-id]');

          if (!variant) {
            variantInput.value = '';
            button.disabled = true;
            if (buyNow) buyNow.disabled = true;
            label.textContent = 'Unavailable';
            return;
          }

          variantInput.value = variant.id;

          this.querySelector('[data-price]').textContent =
            this.money(variant.price);

          const compare = this.querySelector('[data-compare-price]');
          const badge = this.querySelector('[data-discount-badge]');

          const onSale =
            variant.compare_at_price &&
            variant.compare_at_price > variant.price;

          compare.classList.toggle('is-hidden', !onSale);
          badge.classList.toggle('is-hidden', !onSale);

          if (onSale) {
            compare.textContent = this.money(variant.compare_at_price);

            badge.textContent =
              Math.round(
                ((variant.compare_at_price - variant.price) * 100) /
                  variant.compare_at_price
              ) + '% OFF';
          }

          button.disabled = !variant.available;
          if (buyNow) buyNow.disabled = !variant.available;

          label.textContent = variant.available
            ? this.dataset.addLabel
            : this.dataset.soldOutLabel;

          if (variant.featured_media) {
            this.showMedia(String(variant.featured_media.id));
          }

          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url);
        }

        money(cents) {
          return new Intl.NumberFormat(
            document.documentElement.lang || 'en-IN',
            {
              style: 'currency',
              currency: window.Shopify?.currency?.active || 'INR'
            }
          ).format(cents / 100);
        }

        changeQuantity(change) {
          const input = this.querySelector('[name="quantity"]');

          input.value = Math.max(
            Number(input.min || 1),
            Number(input.value || 1) + change
          );

          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
